import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlusMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPlusMedium"><Path d="M12 5V12M12 12V19M12 12H5M12 12H19" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPlusMedium;
